import type Animations from "../types/Animations";

const getAnimation = (animation?: Animations): string =>
  animation === "pulse" ? "animate-pulse-ring" : "";

export default getAnimation;
